import React from 'react';
import { Link } from 'react-router-dom';
import { UserPlus } from 'lucide-react';
import { useLang } from '../../hooks/useLang';
import Navbar from './Navbar';

// Shown instead of a hard redirect when a logged-out visitor tries to open a
// page that needs an account (Dashboard, Library, My Books, ...). A silent
// bounce straight to /login gives no context; this explains why they landed
// here and offers the actual next step.
const AuthGateCard = () => {
  const { language } = useLang();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-24 text-center">
        <div className="w-16 h-16 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mx-auto mb-5">
          <UserPlus className="w-7 h-7" />
        </div>
        <h1 className="text-xl font-bold text-foreground mb-2">You don't have an account yet</h1>
        <p className="text-sm text-muted-foreground mb-6">
          Create a free YeniDers account to use this feature — it only takes a minute.
        </p>
        <Link
          to={`/${language}/signup`}
          className="inline-flex items-center justify-center w-full px-6 py-3 rounded-xl bg-primary text-primary-foreground font-bold text-sm hover:bg-primary/90 transition-all"
        >
          Create a free account
        </Link>
        <p className="text-xs text-muted-foreground mt-4">
          Already have an account?{' '}
          <Link to={`/${language}/login`} className="text-primary font-semibold hover:underline">Log in</Link>
        </p>
      </div>
    </div>
  );
};

export default AuthGateCard;
